import { featureFlagFlags } from '@/plugins/rollout';

export default {
  ...featureFlagFlags
};
